import type { PromoUploadStatusType } from '@entities/adCampaign';
import type { AdPromoPureType } from '@shared/api/graphql/generated';

type PromoStateSource = Pick<
  AdPromoPureType,
  'id' | 'order' | 'promoId' | 'filename' | 'title' | 'time' | 'duration' | 'playDuration' | 'withSound'
> & {
  promoAdId?: string;
  promo?: Pick<AdPromoPureType['promo'], 'type' | 'sourcefiles' | 'previewUrl'> | null;
  videoPromo?: Pick<NonNullable<AdPromoPureType['videoPromo']>, 'id' | 'playDuration' | 'withSound'> | null;
};

export const getMutablePromoStatuses = (statuses: readonly PromoUploadStatusType[]) =>
  statuses.map((status) => {
    const mutable = { ...status } as PromoUploadStatusType & {
      chosen?: boolean;
      filtered?: boolean;
      selected?: boolean;
    };
    delete mutable.chosen;
    delete mutable.filtered;
    delete mutable.selected;
    return mutable;
  });

export const toPromoUploadStatuses = (
  promos: readonly PromoStateSource[],
  createId: () => string
): PromoUploadStatusType[] =>
  [...promos]
    .sort((a, b) => (a.order ?? Infinity) - (b.order ?? Infinity))
    .map((item) => {
      const isLocal = item.id?.startsWith('local_');
      const promoAdId = item.promoAdId || (!isLocal ? item.id : undefined);
      let id = item.id;
      if (!isLocal) id = promoAdId ? `local_${promoAdId}` : createId();
      return {
        id,
        promoId: item.promoId,
        promoAdId,
        videoPromoId: item.videoPromo?.id,
        playDuration: item.videoPromo?.playDuration ?? item.playDuration ?? undefined,
        withSound: item.videoPromo?.withSound ?? item.withSound ?? undefined,
        filename: item.filename,
        title: item.title ?? '',
        time: item.time ?? undefined,
        isLoading: false,
        duration: item.duration,
        type: item.promo?.type,
        sourcefiles: item.promo?.sourcefiles ?? [],
        previewUrl: item.promo?.previewUrl,
      };
    });
